export default __webpack_public_path__ + "static/media/58854EA9-22AF-4FF9-88CE-23A5E495C4BB_1_105_c.1bffadd8.jpeg";